Mmg.addShortcode(

  /**
   *
   * @param {string} shortcodeName The name of the shortcode
   * @param {string} selector The selector used to locate this shortcode in the DOM
   * @param {callable} callback The callback function applied to every element matching the selector
   */
  'contact_form',
  '.sc-contact-form',

  /**
   * @param {Element} el The shortcode's DOM element
   * @param {object} model The data model passed to the shortcode instance in data-json attribute
   * @param {jQuery} $ The callback function applied to every element matching the selector
   * @param {string} selector The shortcode selector that was passed to addShortcode
   * @param {string} className The name of the shortcode class
   */
  (el, model, $, selector, className) => {
    // Widget Declarations
    const $this = $(el);

    // Form elements
    const $form = $(`${selector}__form`);
    const $response = $this.find('.alert');

    /**
     * Initialize the widget
     */
    (function init() {
      addEvents();
    })();


    /**
     * Handle events in the UI
     */
    function addEvents() {
      $form.on('submit', submitForm);
    }

    /**
     * Collect the data and redirect.
     *
     * @param {*} event
     */
    function submitForm(event) {
      event.preventDefault();

      $response.empty().hide();

      $.ajax({
        type: 'POST',
        url: model.apiUrl,
        data: $form.serialize(),
      }).done(function() {
        $response.text('Thank You! Form Submitted Successfully.').addClass('alert-success').show();
      }).fail(function(jqXHR) {
        let errorMessage = jqXHR.responseJSON.message;

        if (jqXHR.responseJSON.data && jqXHR.responseJSON.data.params) {
          const firstParam = Object.keys(jqXHR.responseJSON.data.params)[0];
          errorMessage = jqXHR.responseJSON.data.params[firstParam];
        }

        $response.text(errorMessage).addClass('alert-danger').show();
      });
    }
  }
);
